import { OnlineOrderStatuses } from '../enums/OnlineOrderStatuses';

export const ONLINE_ORDER_STATUS_LABELS: Record<OnlineOrderStatuses, string> = {
  [OnlineOrderStatuses.Open]: 'Offen',
  [OnlineOrderStatuses.Issued]: 'Ausgegeben',
  [OnlineOrderStatuses.Other]: 'Andere'
};
